import { expect } from '@open-wc/testing';
import { toDashCase } from './to-dashcase.js';

describe('utils', () => {
  describe('toDashCase', () => {
    it('converts camel case to dash case', async () => {
      expect(toDashCase('myCamelCase')).to.equal('my-camel-case');
    });
  });
});
